const KEY_CLIENTE = 'srn_cliente'

export default {
  _temKey() {
    return localStorage.getItem(KEY_CLIENTE) !== null
  },
  getCliente() {
    if (this._temKey()) {
      const retorno = JSON.parse(localStorage.getItem(KEY_CLIENTE))
      localStorage.removeItem(KEY_CLIENTE)
      return retorno
    }

    return null
  },
  setCliente(cliente) {
    localStorage.setItem(KEY_CLIENTE, JSON.stringify(cliente))
  },
}
